import classNames from "classnames";
import { useEffect, useState } from "react";
import * as expirationCountdownCss from "./expiration-countdown.module.css";

export const ExpirationCountdown = ({
  initialMilliseconds,
}: {
  initialMilliseconds: number;
}) => {
  const [milliseconds, setMilliseconds] = useState(initialMilliseconds);

  useEffect(() => {
    if (milliseconds <= 0) {
      return undefined;
    }

    const timerId = setTimeout(() => {
      setMilliseconds(milliseconds - 1000);
    }, 1000);

    return () => clearTimeout(timerId);
  }, [milliseconds]);

  const getExpirationText = (time: number) => {
    const durationString = getDaysHoursMinutesSecondsFromMs(time).fullFormat;
    return durationString;
  };

  return (
    <div>
      {"Expires in "}
      <span className={classNames(expirationCountdownCss.bold)}>
        {getExpirationText(milliseconds)}
      </span>
    </div>
  );
};

export const getDaysHoursMinutesSecondsFromMs = (milliseconds: number) => {
  const days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (milliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
  );
  const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((milliseconds % (1000 * 60)) / 1000);
  return {
    fullFormat: `${days}d ${hours}h ${minutes}m ${seconds}s`,
    highestValueFormat:
      days > 0
        ? `${days} day${days !== 1 ? "s" : ""}`
        : hours > 0
          ? `${hours} hour${hours !== 1 ? "s" : ""}`
          : minutes > 0
            ? `${minutes} minute${minutes !== 1 ? "s" : ""}`
            : `${seconds} second${seconds !== 1 ? "s" : ""}`,
  };
};
